import { apiClient } from "../api/internal";

function useApiClient() {
  return apiClient;
}

export default useApiClient;
